export default "__VITE_ASSET__06c0398c__"